<template>
    <hox-alert type="info" size="small">
        <template #title>
            <p>This could take a while</p>
        </template>

        <template #content>
            <p>
                You will be notified when they are ready to download and you will be able to find download links in your
                notifications.
            </p>

            <p v-if="isLargeImageScale">
                <br />
                At {{ imageScale }}×, each image contains {{ imageScale * imageScale }}× as many pixels as a 1× export.
                This increases rendering time and significantly increases the archive size.
            </p>

            <p v-if="isGenericLiteDownload">
                <br />
                Please make sure you read the
                <span class="download-modal__changes-overview-link" @click="emit('tabChange', 'changesOverview')">
                    changes overview
                </span>
                tab to understand the limitations of this format before downloading.
            </p>
        </template>
    </hox-alert>
</template>

<script lang="ts" setup>
import { EXPORT_FORMAT, type ExportFormatType } from "shared-utils/enums/exports";
import { computed } from "vue";

import { useDownloadHTMLZip } from "@/composables/download/useDownloadHTMLZip";

const { exportFormat } = defineProps<{
    exportFormat: ExportFormatType;
}>();

const emit = defineEmits<(e: "tabChange", tab: "downloadOptions" | "changesOverview") => void>();

const { imageScale } = useDownloadHTMLZip();

const isGenericLiteDownload = computed(() => {
    return exportFormat === EXPORT_FORMAT.GENERIC_LITE;
});

const isLargeImageScale = computed(() => {
    return imageScale.value > 2;
});
</script>

<style lang="scss" scoped>
@use "@style/variables" as *;
.download-modal__changes-overview-link {
    color: $primary-color;
    text-decoration: underline;
    cursor: pointer;
}
</style>
